import ApplicationSerializer from 'lumen/serializers/application';

export default class CentralMappingPmsValueTypeSerializer extends ApplicationSerializer {
  primaryKey: string = 'value_type';
}
